import React, { useEffect, useRef, useState } from "react";
import LayoutContainer from "../../../components/Containers/LayoutContainer";
import {
  Download,
  File,
  Files,
  FilesAlt,
  HandThumbsUp,
  TrashFill,
} from "react-bootstrap-icons";
import PageHeader from "../../../components/PageHeader/PageHeader";
import CommonTable, {
  TableColumn,
} from "../../../components/Table/CommonTable";
import { ModalRef } from "../../../utils/constants/Interfaces.constants";
import ModalWrapper from "../../../components/Modal/ModalWrapper";
import CustomButton from "../../../components/CustomButton/CustomButton";
import { useNavigate } from "react-router-dom";
import { fetchMedia, postDetails } from "../../../services/http/http.service";
import APIList from "../../../utils/constants/APIList";
import { useAppDispatch } from "../../../store/storeRequests";
import { hideLoader, showLoader } from "../../../store/Loader/loader.slice";
import { Modal } from "react-bootstrap";
import convertTimestamp from "../../../utils/helpers/convertTimeStamp";
import DownloadExcel from "../../Download_Excel/download_Excel";
import defaultProfile from "../../../assets/default-profile.png";
import sortByCreated from "../../../utils/helpers/sortByCreated";
import formatDate from "../../../utils/helpers/formatDate";
import { hideToast, showToast } from "../../../store/Toast/toast.slice";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import * as XLSX from "xlsx";
import Select from "react-select";
import { customSingleSelectStyles } from "../../../utils/constants/CustomStyles.constants";
import useDebounce from "../../../hooks/useDebounce";

interface Folder {
  id: number;
  folderName: string;
  created: Date;
  count: number;
  media_type: string;
  mediaName: string;
}

const Gallery: React.FunctionComponent = () => {
  const dispatch = useAppDispatch();

  // const [addfolders, setAddFolders] = useState<[]>([]);
  const [galleryList, setGalleryList] = useState<[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  // const [selectedImage, setSelectedImage] = useState<string>("");
  const [selectedMedia, setSelectedMedia] = useState<Folder | null>(null);
  const [viewData, setViewData] = useState([]);
  // const [viewUsers, setViewUsers] = useState([]);
  const downloadExcelRef = useRef<any>(null);
  const [mediaType, setMediaType] = useState<string>("image");
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [dateErrors, setDateErrors] = useState({
    startDateError: "",
    endDateError: "",
  });
  const [isDownloading, setIsDownloading] = useState(false);
  const [showDownloadViewUsersModal, setShowDownloadViewUsersModal] =
    useState(false);
  const [showDownloadMediaModal, setShowDownloadMediaModal] = useState(false);
  const [selectedMediaType, setSelectedMediaType] = useState(null);
  const [totalRecords, setTotalRecords] = useState(0);
  // const [totalRecords, setTotalRecords] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const debouncedSearchQuery = useDebounce(searchQuery, 500);


  const mediaOptions = [
    { value: "image", label: "Image" },
    { value: "video", label: "Video" },
  ];

  const cmpMounted = useRef(false);

  useEffect(() => {
    if (cmpMounted.current === true) return;
    cmpMounted.current = true;
    fetchGetAllGalleryList();
  }, []);

  useEffect(() => {
    const fetchDataAndUpdate = async () => {
      // const data = await fetchData(searchQuery, 5, 1); 
      await fetchGetAllGalleryList( 1, debouncedSearchQuery);
      // setTableData(data?.result || []);
    };
    fetchDataAndUpdate();
  }, [debouncedSearchQuery]);

  const fetchGetAllGalleryList = async (page: any = 1,  query: string = "") => {
    try {
      dispatch(showLoader("Loading data..."));
      let payload;
      if(query.length > 0) {
        payload = {
          filter: query.trim()
        };
      } else {
        payload = {
          pageSize: 10,
          pageNumber: page,
          // filter: query.trim()
        };
      }
      
      // console.log(payload)
      const response = await postDetails(APIList.gallery_list, payload);
      // console.log("RESPONSE", response)
      setTotalRecords(response.data.totalcount);
      const sortedData = sortByCreated(response.data.data);
      const modifiedData = sortedData.map((item: Folder) => ({
        ...item,
        created: new Date(item.created).toLocaleString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        }),
      }));
      setGalleryList(modifiedData || []);
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(showToast("Error fetching data."));
      setTimeout(() => dispatch(hideToast()), 3000);
    } finally {
      dispatch(hideLoader());
    }
  };

  const modalRef = useRef<ModalRef>(null);
  const countLikeRef = useRef<ModalRef>(null);
  const viewRef = useRef<any>(null);
  const navigate = useNavigate();

  const handleDownloadViewUsers = async (ev: React.FormEvent) => {
    ev.preventDefault();

    let errors = { startDateError: "", endDateError: "" };
    const today = new Date();

    // Validate start date (No validation needed since it can be any date)
    if (!startDate) {
      errors.startDateError = "Please select a start date.";
    }

    // Validate end date
    if (!endDate) {
      errors.endDateError = "Please select an end date.";
    } else if (endDate < startDate!) {
      errors.endDateError = "End date cannot be earlier than start date.";
    } else if (endDate > today) {
      errors.endDateError = "End date cannot be later than today.";
    }

    setDateErrors(errors);
    if (!errors.startDateError && !errors.endDateError) {
      const formattedStartDate = startDate
        ? format(startDate, "dd-MM-yyyy")
        : "";
      const formattedEndDate = endDate ? format(endDate, "dd-MM-yyyy") : "";

      const payload = {
        fromDate: formattedStartDate,
        toDate: formattedEndDate,
      };

      // console.log(payload);

      try {
        setIsDownloading(true);
        const response = await postDetails(APIList.VIEW_USER, payload);
        // console.log("View Users",response)

        if (response.statusCode === 200) {
          if (response.data.length === 0) {
            dispatch(showToast("No user available for selected date"));
            setTimeout(() => dispatch(hideToast()), 3000);
          } else {
            // setViewUsers(response.data)
            const worksheet = XLSX.utils.json_to_sheet(response.data);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "ViewUsers");

            // Generate and trigger download
            XLSX.writeFile(
              workbook,
              `View_Users_${formattedStartDate}_to_${formattedEndDate}.xlsx`
            );
            dispatch(showToast("View users downloaded successfully"));
            setTimeout(() => dispatch(hideToast()), 3000);
          }
        } else {
          dispatch(showLoader("Unable to fetch view users"));
          setTimeout(() => dispatch(hideToast()), 3000);
        }
      } catch (error) {
        console.error(error);
        dispatch(showToast("Some error occurred while downloading view users"));
        setTimeout(() => dispatch(hideToast()), 3000);
      } finally {
        handleCloseDownloadMediaModal();
        setIsDownloading(false);
        dispatch(hideLoader());
      }
    }
  };

  const handleMediaTypeChange = (option: any) => {
    setSelectedMediaType(option);
    setMediaType(option.value);
  };

  const handleMediaDownload = async (
    ev: React.FormEvent
    // media_type: string = "image"
  ) => {
    ev.preventDefault();
    // Ensure that fromDate and toDate are not null
    let errors = { startDateError: "", endDateError: "" };
    const today = new Date();

    // Validate start date (No validation needed since it can be any date)
    if (!startDate) {
      errors.startDateError = "Please select a start date.";
    }

    // Validate end date
    if (!endDate) {
      errors.endDateError = "Please select an end date.";
    } else if (endDate < startDate!) {
      errors.endDateError = "End date cannot be earlier than the start date.";
    } else if (endDate > today) {
      errors.endDateError = "End date cannot be later than today.";
    }

    setDateErrors(errors);
    if (!errors.startDateError && !errors.endDateError) {
      const formattedStartDate = startDate
        ? format(startDate, "dd-MM-yyyy")
        : "";
      const formattedEndDate = endDate ? format(endDate, "dd-MM-yyyy") : "";

      const payload = {
        fromDate: formattedStartDate,
        toDate: formattedEndDate,
        media_type: mediaType,
      };


      let response: any;
      try {
        setIsDownloading(true);
        dispatch(showLoader("Downloading Media..."));
        response = await fetchMedia(APIList.DOWNLOAD_MEDIA, payload);
        dispatch(showToast(response.message));
        setTimeout(() => dispatch(hideToast()), 3000);
      } catch (error) {
        console.error(error);
        dispatch(showToast("Some error occurred while downloading media"));
        setTimeout(() => dispatch(hideToast()), 3000);
      } finally {
        handleCloseDownloadMediaModal();
        setIsDownloading(false);
        dispatch(hideLoader());
      }
    }
  };

  const handleCloseDownloadMediaModal = () => {
    setStartDate(null);
    setEndDate(null);
    setSelectedMediaType(null);
    setShowDownloadViewUsersModal(false);
    setShowDownloadMediaModal(false);
    setDateErrors({
      startDateError: "",
      endDateError: "",
    });
  };

  const handlePageChange = (page: number) => {
    fetchGetAllGalleryList(page + 1);
  };

  const openAddFolderModal = () => {
    navigate("/gallery/add-gallery");
    // if (modalRef.current) {
    //     modalRef.current.toggleModalWrapper(true)
    // }
  };

  const viewCount = async (item: Folder) => {
    try {
      const payload = {
        id: item.id,
      };
      //   dispatch(showLoader("Loading data..."));
      const response = await postDetails(APIList.ViewUserLIkeList, payload);
      if (Array.isArray(response.data) && response.data.length !== 0) {
        setViewData(response.data || []);
        setShowViewModal(true);
      }
    } catch (error) {
      console.error("Error fetching details:", error);
      dispatch(showToast("Error fetching details"));
      setTimeout(() => dispatch(hideToast()), 3000);
    } finally {
      //   dispatch(hideLoader());
    }
  };

  const deleteItemById = async (item: Folder) => {
    try {
      dispatch(showLoader("Loading data..."));
      const response = await postDetails(APIList.delete_gallery, {
        id: item.id,
      });
      if (response.status === "Failed") {
        dispatch(showToast("Cannot delete item"));
        setTimeout(() => dispatch(hideToast()), 3000);
        return;
      }
      setGalleryList((prevData: any) =>
        prevData.filter((row: Folder) => row.id !== item.id)
      );
    } catch (error) {
      console.error("Error deleting item:", error);
      dispatch(
        showToast(
          "An error occurred while trying to delete the item. Please try again."
        )
      );
      setTimeout(() => dispatch(hideToast()), 3000);
    } finally {
      dispatch(hideLoader());
    }
  };

  const handleGalleryPreview = (item: Folder) => {
    setSelectedMedia(item);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedMedia(null);
  };

  const handleCloseViewModal = () => {
    setShowViewModal(false);
  };

  const handleSearch = (searchTerm: string) => {
    setSearchQuery(searchTerm);
  };

  const columns: TableColumn[] = [
    {
      key: "created",
      label: "Image Date",
      dataType: "string",
      // render: (record) =>
      //   new Date(record.created).toLocaleString("en-GB", {
      //     day: "2-digit",
      //     month: "2-digit",
      //     year: "numeric",
      //     hour: "2-digit",
      //     minute: "2-digit",
      //     hour12: true,
      //   }),
      sortable: true,
      // search:true
    },
    {
      key: "folderName",
      label: "Folder Name",
      sortable: true,
      dataType: "string",
      // search:true
    },
    {
      key: "mediaName",
      label: "Preview",
      dataType: "button",
      button: {
        label: "View",
        onClick: (item) => handleGalleryPreview(item),
      },
    },
    // { key: "count", label: "View Count",
    // }
    {
      key: "count",
      label: "View Count",
      sortable: true,
      // search:true,
      render: (item) => {
        return (
          <div
            className="text-primary cursor-pointer text-decoration-underline"
            onClick={() => viewCount(item)}
          >
            {" "}
            {item.count || 0}{" "}
          </div>
        );
      },
    },
  ];

  const buttons = [
    {
      label: "Add Media",
      theme: "warning",
      // icon: <TrashFill />,
      onClick: openAddFolderModal,
    },
    // {
    //     label:"Back To Main List",
    //     theme:"danger",
    //     icon: <ArrowLeft />,
    // }
    {
      label: "Download Media",
      theme: "warning",
      icon: <Download />,
      onClick: () => setShowDownloadMediaModal(true),
    },
    {
      label: "Download - View Users",
      theme: "warning",
      icon: <FilesAlt />,
      onClick: () => setShowDownloadViewUsersModal(true),
    },
  ];

  return (
    <LayoutContainer title="living-responsibility">
      {/* <DownloadExcel
        ref={downloadExcelRef}
        excelData={viewUsers}
        fileName="Photo_View_Users"
        buttonText=""
      /> */}

      <Modal
        show={showDownloadMediaModal}
        onHide={handleCloseDownloadMediaModal}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Select Date Range</Modal.Title>
        </Modal.Header>
        <Modal.Body
        // style={{overflowY:"visible"}}
        >
          <form
            onSubmit={(ev) => {
              handleMediaDownload(ev);
            }}
          >
            <div
              className="d-flex justify-content-between gap-4 font-12"
              style={{ marginBottom: "40px" }}
            >
              <div className="height-50px">
                <label>
                  Start Date: <span className="text-danger">*</span>
                </label>
                <DatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  selectsStart
                  startDate={startDate}
                  maxDate={new Date()}
                  endDate={endDate}
                  onKeyDown={(e: any) => {
                    e.preventDefault();
                  }}
                  required
                  dateFormat="dd-MM-yyyy"
                  placeholderText="Select start date"
                  className={`mf-admin-inputfield`}
                  showMonthDropdown // Add month dropdown
                  showYearDropdown // Add year dropdown
                  dropdownMode="select"
                />
                {dateErrors.startDateError && (
                  <div className="error-text">{dateErrors.startDateError}</div>
                )}
              </div>

              <div className="height-50px">
                <label>
                  End Date: <span className="text-danger">*</span>
                </label>
                <DatePicker
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                  selectsEnd
                  startDate={startDate}
                  endDate={endDate}
                  minDate={startDate}
                  maxDate={new Date()}
                  onKeyDown={(e: any) => {
                    e.preventDefault();
                  }}
                  required
                  dateFormat="dd-MM-yyyy"
                  placeholderText="Select end date"
                  className={`mf-admin-inputfield`}
                  showMonthDropdown // Add month dropdown
                  showYearDropdown // Add year dropdown
                  dropdownMode="select"
                />
                {dateErrors.endDateError && (
                  <div className="error-text">{dateErrors.endDateError}</div>
                )}
              </div>
            </div>

            <div
              className="height-50px font-12"
              style={{ marginBottom: "40px" }}
            >
              <label>
                Select Media Type: <span className="text-danger">*</span>
              </label>
              <Select
                value={selectedMediaType}
                styles={customSingleSelectStyles}
                onChange={handleMediaTypeChange}
                options={mediaOptions}
                placeholder="Select media type"
                required
                isSearchable={false}
              />
            </div>

            <div>
              <CustomButton
                theme="yellow"
                type="submit"
                size="md"
                disabled={isDownloading}
              >
                Download
              </CustomButton>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <Modal
        show={showDownloadViewUsersModal}
        onHide={handleCloseDownloadMediaModal}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Select Date Range</Modal.Title>
        </Modal.Header>
        <Modal.Body
        // style={{overflowY:"visible"}}
        >
          <form
            onSubmit={(ev) => {
              handleDownloadViewUsers(ev);
            }}
          >
            <div
              className="d-flex justify-content-between gap-4 font-12"
              style={{ marginBottom: "60px" }}
            >
              <div className="height-50px">
                <label>
                  Start Date: <span className="text-danger">*</span>
                </label>
                <DatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  selectsStart
                  startDate={startDate}
                  maxDate={new Date()}
                  endDate={endDate}
                  required
                  dateFormat="dd-MM-yyyy"
                  placeholderText="Select start date"
                  onKeyDown={(e: any) => {
                    e.preventDefault();
                  }}
                  className={`mf-admin-inputfield`}
                  showMonthDropdown // Add month dropdown
                  showYearDropdown // Add year dropdown
                  dropdownMode="select"
                />
                {dateErrors.startDateError && (
                  <div className="error-text">{dateErrors.startDateError}</div>
                )}
              </div>

              <div className="height-50px">
                <label>
                  End Date: <span className="text-danger">*</span>
                </label>
                <DatePicker
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                  selectsEnd
                  startDate={startDate}
                  endDate={endDate}
                  minDate={startDate}
                  maxDate={new Date()}
                  onKeyDown={(e: any) => {
                    e.preventDefault();
                  }}
                  required
                  dateFormat="dd-MM-yyyy"
                  placeholderText="Select end date"
                  className={`mf-admin-inputfield`}
                  showMonthDropdown // Add month dropdown
                  showYearDropdown // Add year dropdown
                  dropdownMode="select"
                />
                {dateErrors.endDateError && (
                  <div className="error-text">{dateErrors.endDateError}</div>
                )}
              </div>
            </div>

            <div>
              <CustomButton
                theme="yellow"
                type="submit"
                size="md"
                disabled={isDownloading}
              >
                Download
              </CustomButton>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <Modal show={showViewModal} onHide={handleCloseViewModal}>
        <Modal.Header closeButton>
          <Modal.Title>Viewers</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className="mb-2"
            style={{
              height: "300px",
              overflowY: "auto",
            }}
          >
            {viewData.map((user: any) => (
              <div
                key={user.id}
                className="d-flex my-2 justify-content-between align-items-center"
              >
                <div className="d-flex align-items-center">
                  <img
                    src={user.profile ? user.profile : defaultProfile}
                    alt="Profile Picture"
                    className="mx-4"
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "50%",
                      marginRight: "10px",
                    }}
                  />
                  <div className="">
                    <p
                      className="text-start px-2"
                      style={{
                        fontWeight: "700",
                        fontSize: 16,
                        marginBottom: "0.5rem",
                      }}
                    >
                      {user.username || "User Name Not Available"}
                    </p>
                    <p className="text-start px-2" style={{ fontSize: 14 }}>
                      {user.created
                        ? new Date(user.created).toLocaleString("en-GB", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })
                        : "Date Not Available"}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <CustomButton
            theme="yellow"
            type="button"
            size="md"
            onClick={handleCloseViewModal}
          >
            Close
          </CustomButton>
        </Modal.Footer>
      </Modal>

      {/* <ModalWrapper ref={countLikeRef} title="Like">
                <div  style={{
                        maxHeight: "500px",
                        overflowY: "auto",
                        padding: "10px",    
                    }}>
                    {likesData.map((like: any) => (
                        <div
                            key={like.id}
                            className="d-flex my-2  justify-content-between align-items-center border shadow-sm"
                        >
                            <div className="d-flex  align-items-center">
                                <img
                                    src={
                                        like.profile
                                            ? like.profile
                                            : "default-profile-pic-url"
                                    }
                                    alt="Profile Picture"
                                    className="mx-4"
                                    style={{
                                        width: "50px",
                                        height: "50px",
                                        borderRadius: "50%",
                                        marginRight: "10px",
                                    }}
                                />
                                <div className="">
                                    <p
                                        className="text-start px-2"
                                        style={{ fontWeight: "700", fontSize: 20 }}
                                    >
                                        {like.username || "User Name Not Available"}
                                    </p>
                                    <p className="text-start px-2" style={{ fontSize: 15 }}>
                                        {like.created
                                            ? new Date(like.created).toLocaleString("en-GB", {
                                                day: "2-digit",
                                                month: "2-digit",
                                                year: "numeric",
                                                hour: "2-digit",
                                                minute: "2-digit",
                                                hour12: true,
                                            })
                                            : "Date Not Available"}
                                    </p>
                                </div>
                            </div>
                            <div className=' px-2'>{like.count}</div>
                        </div>
                    ))}


                    <CustomButton theme="yellow" type="button" size="sm">
                        <span className="" onClick={closeModal}>Close </span>
                    </CustomButton>
                </div>


            </ModalWrapper> */}
      <div className=" page-header d-flex align-items-center justify-content-left dashboard-container h-100">
        <h2>
          <i className="page-header-icon fa fa-home"></i>
          Gallery
        </h2>
        <PageHeader buttons={buttons} />
      </div>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Media Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{
          maxHeight: "400px",
          overflowY: "auto"
        }}>
          <div style={{ height: "300px", width: "100%", overflow: "hidden" }}>
            {selectedMedia?.media_type === "Image" ? (
              <img
                src={selectedMedia.mediaName}
                alt="Preview"
                // style={{ width: "100%" }}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain", // Maintain aspect ratio and fit inside the div
                }}
              />
            ) : selectedMedia?.media_type === "Video" ? (
              <video
                controls
                //  style={{ width: "100%" }}
                style={{ width: "100%", height: "100%", objectFit: "contain" }}
              >
                <source src={selectedMedia.mediaName} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            ) : (
              <p>Unsupported media type.</p>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <CustomButton
            theme="yellow"
            type="button"
            size="md"
            onClick={handleCloseModal}
          >
            Close
          </CustomButton>
        </Modal.Footer>
      </Modal>

      <CommonTable<Folder>
        data={galleryList}
        columns={columns}
        // onEdit={editItem}
        onDelete={deleteItemById}
        // onStatusToggle={(item)=> console.log(item)}
        pagination={true}
        // onStatusToggle={toggleStatus}
        rowsPerPage={10}
        apiPagination={true}
        onPageChange={handlePageChange}
        totalPageCount={totalRecords}
        actions={{
          view: false,
          edit: false,
          delete: true,
          checkbox: false,
          status: false,
          showModal: false,
        }}
        apiSearch={true}
        onSearch={handleSearch}
      // totalPageCount={totalRecords}
      // onPageChange={handlePageChange}
      // apiPagination={true}
      />
    </LayoutContainer>
  );
};

export default Gallery;
